import axios from "axios";
import {
  clearLocalStorage,
  getLocalStorage,
} from "src/utils/helper";
import { store } from "src/store";
import { logOutAction } from "./auth";
import { showToast } from "src/customHooks/ToastEmitter";

export const API_URLS = {
  baseURL:
    window._env_?.REACT_APP_BASE_URL_MAIN_VAYU ||
    process.env.REACT_APP_BASE_URL_MAIN_VAYU,
};

export const instance = axios.create({
  baseURL: API_URLS.baseURL,
  timeout: 30000,
});

// ✅ REQUEST INTERCEPTOR (ATTACH TOKEN)
instance.interceptors.request.use(
  async (config: any) => {
    const token = await getLocalStorage("access_token");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ LOGOUT HANDLER
const logoutUser = () => {
  try {
    store.dispatch(logOutAction());
  } catch {}

  clearLocalStorage();
  window.location.replace("/login");
};

// ✅ RESPONSE INTERCEPTOR (NO REFRESH TOKEN LOGIC)
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.code === "ERR_NETWORK") {
      showToast("Network error occurred", { appearance: "error" });
      return Promise.reject(error);
    }

    const status = error?.response?.status;
    const message =
      error?.response?.data?.message || "Something went wrong";

    if (status === 401) {
      showToast("Session expired. Please login again.", {
        appearance: "error",
      });
      logoutUser();
    } else if (status === 500 || status === 502) {
      showToast("Server error", { appearance: "error" });
    } else if (status === 404) {
      showToast("API not found", { appearance: "error" });
    } else {
      showToast(message, { appearance: "error" });
    }

    return Promise.reject(error?.response || error);
  }
);

export default instance;